<template>
  <div class="wrap">
    <div class="banner">
      <div class="text animated fadeIn">
        <p class="icon"></p>
        <p class="h2">关于我们</p>
      </div>
    </div>
    <div class="content bg"
         id="a1">
      <div class="en t1"></div>
      <div class="inner product">
        <h2>公司<em>简介</em></h2>
        <div class="details">
          <div class="img">
            <div class="p1"></div>
            <div class="p2"><img src="../../assets/images/airsep/about1.jpg" /></div>
          </div>
          <div class="text">
            <p>
              埃珥赛璞医疗是集投资、研发、制造及运营为一体的高科技医疗装备和医疗器械企业，
              借势珠三角地区改革开放前沿和国际金融、贸易、制造和研发中心的领先地理位置，
              凭借国际最新的第三代医用中心制氧系统、医用气体系统、国内独家的小型医用中心制氧系统等一系列高技术医院项目，
              具有覆盖全国的投资和营销能力，能为全国代理商和医院提供完备的运营服务和技术支持。
              设备研发和制造基地设在长沙国际高新工业园区，公司从事医院各领域高技术医疗设备与器械研发、制造已逾17年，
              目前已经成为加美国埃珥赛璞系列高科技医院装备的中国进口制造代理商售后服务商，
              并独立研发制造具有国际领先水准的第三代医用中心制氧系统、医用气体系统、
              小型医用中心制氧系统等一系列高技术医用装备，这些装备全部具有高科技化、
              自动化、网络化、低维护性特点。 我们采用进口配件和自主专利制造的医用气体系统已在全国100多家医院安装使用，
              目前有设备最长寿命记录已经达到16年，而且仍在正常运行，可见制造工艺和技术水准是可靠的，值得客户信赖。
              目前我公司已在全国除西藏、甘肃以外的全部省区设有技术服务中心和办事处，能够做到全国范围内3-24小时应急维修响应，
              能够随时为医院和代理商提供项目讲解、学术培训、技术支持、物料供应、维修、维保等服务。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="content"
         id="a2">
      <div class="en t2"></div>
      <div class="inner product">
        <h2>创始人<em>团队</em></h2>
        <div class="step">
          <div v-for="(item, index) in teamList" :key="index" class="stepimgtit">
            <div class="img">
              <img :src="item.url" />
            </div>
            <div class="tit">
              <p>{{ item.name }}</p>
              <p>{{ item.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content bg"
         id="a3">
      <div class="en t5"></div>
      <div class="inner product">
        <h2>资质<em>认证</em></h2>
        <div class="details2">
          <ul>
            <li v-for="(item, index) in certificateList" :key="index">
              <img :src="item.url" />
              <div class="overlay">
                <p>{{ item.title }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content"
         id="a4">
      <div class="en t4"></div>
      <div class="inner product">
        <h2>企业<em>文化</em></h2>
        <div class="details3">
          <div class="img">
            <div class="p2"><img src="../../assets/images/airsep/wenhua.jpg" /></div>
          </div>
          <div class="tit">
            <h3>※公司理念：</h3>
            <p>1.以人才为根本，以市场为向导；</p>
            <p>2.以技术为核心，以质量为依托；</p>
            <p>3.以创新为保障，以发展为目标。</p>
          </div>
          <div class="tit">
            <h3>※质量目标：</h3>
            <p>1.交付产品致命缺陷为零</p>
            <p>2.生产直通率>=98%</p>
            <p>3.每月客戶投诉低于2起</p>
          </div>
          <div class="tit">
            <h3>※质量方针：</h3>
            <p>高质量、高效率；守承诺，重持续！一直以"用户为先，优质为本"，沿着"追求至美"的服务精神，使您与我公司在激烈竞争的二十一世纪达到双赢。</p>
          </div>
          <div class="tit">
            <h3>※经营理念：</h3>
            <p>助力医院 服务健康</p>
          </div>
          <div class="tit">
            <h3>※服务宗旨：</h3>
            <p>帮助医院实现技术与服务升级，从研发、生产到与医院合作运营，一站式解决医院</p>
          </div>
          <div class="tit">
            <p>一直以“用户为先，优质为本”，沿着“追求至美”的服务精神，使您与我公司在激烈竞争的二十一世纪达到双赢。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content"
         id="a5">
      <div class="en t4"></div>
      <div class="inner product">
        <h2>公司<em>风采</em></h2>
        <div class="details4">
          <p>广州埃珥赛璞医疗设备有限公司于2017年迁入三大国家级中央商务区之一的天河CBD珠江新城</p>
          <ul>
            <li v-for="(item, index) in corporateStyleList" :key="index">
              <img :src="item.url" />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tab fixed"
         v-show="isFixed">
      <div class="inner">
        <a href="javascript:;"
           v-for="(item, index) in jobTitle"
           :key="index"
           :class="{active:index === isActive}"
           @click="goAnchor('#a' + (index + 1), index)">{{ item }}</a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'About',
  metaInfo: {
    title: '广州埃珥赛璞医疗设备有限公司-关于我们', // set a title
    meta: [{ // set meta
      name: '医疗系统开发，医疗大数据应用，软件系统研发与集成，医疗装备研发生产与集成，数字病区',
      content: '广州埃珥赛璞医疗设备有限公司，是集医疗系统开发、医疗大数据应用、软件系统研发与集成、医疗装备研发生产与集成、投资、销售与运营服务为一体的高科技企业，项目坐落在中国光谷。'
    }],
    link: [{ // set link
      rel: '广州埃珥赛璞医疗设备有限公司',
      href: 'http://www.ytwdwh.com/'
    }]
  },
  props: {
    scrollTopNum: Number
  },
  data () {
    return {
      isActive: 0,
      jobTitle: ['公司简介', '创始人团队', '资质认证', '企业文化', '公司风采'],
      zsTitle: ['软件著作证书', '软件产品证书', '企业资质证书'],
      zsActive: 0,
      isFixed: false,
      pageTop: {
        a1: 0,
        a2: 0,
        a3: 0,
        a4: 0,
        a5: 0
      },
      teamList: [
        {
          url: require('../../assets/images/airsep/name4.png'),
          name: '项目发起人：邢晓幕',
          title: '武汉大学工商管理研究生毕业,曾任武汉市外经委主任秘书、办公室副主任。1999年下海从事医疗行业经营管理,历任深圳健安、香港澳美、香港珮夫人、广东万年青、泽荣医药大区经理、全国总监职位。从2012年开始接手中心制氧系统的技术引进、销售、运营及创新销售模式,现任埃珥赛璞医疗总经理、项目创始人。'
        },
        {
          url: require('../../assets/images/airsep/name88.jpg'),
          name: '项目财务及行政负责人：童军',
          title: '中南财经政法大学企业财税专业研究生,历任国企、央企、主板上市公司财务运营总监等职,曾任央企小水电BOT模式上市公司财务运营总监,有丰富的BOT 模式财务运作经验及合理避税运营经验;现任埃珥赛璞医疗财务行政副总经理、合伙创始人。'
        }
      ],
      certificateList: [
        {
          url: require('../../assets/images/airsep/zhengshu1.png'),
          title: 'Ⅱ类耗材证'
        },
        {
          url: require('../../assets/images/airsep/zhengshu2.png'),
          title: '解吸器发明专利证书'
        },
        {
          url: require('../../assets/images/airsep/zhengshu3.png'),
          title: '解吸器实用新型专利证书'
        },
        {
          url: require('../../assets/images/airsep/zhengshu4.png'),
          title: '医用中心制氧系统软件'
        },
        {
          url: require('../../assets/images/airsep/zhengshu5.png'),
          title: '营业执照副本'
        },
        {
          url: require('../../assets/images/airsep/zhengshu6.png'),
          title: '营业执照正本'
        }
      ],
      corporateStyleList: [
        {
          url: require('../../assets/images/airsep/fengcai1.jpg')
        },
        {
          url: require('../../assets/images/airsep/fengcai2.jpg')
        },
        {
          url: require('../../assets/images/airsep/fengcai3.jpg')
        },
        {
          url: require('../../assets/images/airsep/fengcai4.jpg')
        },
        {
          url: require('../../assets/images/airsep/fengcai5.png')
        }
      ]
    }
  },
  mounted () {
    this.pageTop.a1 = this.$el.querySelector('#a1').offsetTop
    this.pageTop.a2 = this.$el.querySelector('#a2').offsetTop
    this.pageTop.a3 = this.$el.querySelector('#a3').offsetTop
    this.pageTop.a4 = this.$el.querySelector('#a4').offsetTop
    this.pageTop.a5 = this.$el.querySelector('#a5').offsetTop
  },
  watch: {
    scrollTopNum (val) {
      // val > 450 ? this.isFixed = true : this.isFixed = false
      // 距离顶部距离设置为固定
      val > this.pageTop.a1 ? this.isFixed = true : this.isFixed = false
      // 根据顶部距离定位锚点
      // if (val > this.pageTop.a1 && val < this.pageTop.a2) {
      //   this.isActive = 0
      // } else if (val > this.pageTop.a2 && val < this.pageTop.a3) {
      //   this.isActive = 1
      // } else if (val > this.pageTop.a3 && val < this.pageTop.a4) {
      //   this.isActive = 2
      // } else if (val > this.pageTop.a4 && val < this.pageTop.a5) {
      //   this.isActive = 3
      // } else if (val > this.pageTop.a5) {
      //   this.isActive = 4
      // }
      console.log(val)
      if (val > this.pageTop.a1 && val < this.pageTop.a2) {
        this.isActive = 0
      } else if (val > 467 && val < 1500) {
        this.isActive = 0
      } else if (val > 1533 && val < 2567) {
        this.isActive = 1
      } else if (val > 2567 && val < 3900) {
        this.isActive = 2
      } else if (val > 3900 && val < 5133) {
        this.isActive = 3
      } else if (val > 5133) {
        this.isActive = 4
      }
    }
  },
  methods: {
    goAnchor (selector, index) {
      // this.isActive = index
      this.$el.querySelector(selector).scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start' // 上边框与视窗顶部平齐, 默认值
      })
    }
    // chenge (index) {
    //   this.zsActive = index
    // }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 444px;
  margin-top: 76px;
  background: url('../../assets/images/banner1.png') no-repeat center;
  text-align: center;
  overflow: hidden;
  .text {
    display: inline-block;
    margin: 117px auto 0;
  }
  .icon {
    width: 105px;
    height: 105px;
    margin: 0 auto;
    background: url('../../assets/images/banner1-icon.png') no-repeat center;
  }
  .h2 {
    font-size: 30px;
    color: #fff;
    margin-top: 62px;
  }
}
.bg {
  background: #fafafa;
}
.content {
  position: relative;
  padding: 80px 0 55px;
  .en {
    width: 100%;
    height: 69px;
    text-align: center;
    border-bottom: 1px solid #f3f3f3;
    position: absolute;
    top: 80px;
    left: 0;
    background-position: center top;
    background-repeat: no-repeat;
    &.t1 {
      background-image: url('../../assets/images/Company-introduction.png');
    }
    &.t2 {
      background-image: url('../../assets/images/Enterprise-development.png');
    }
    &.t3 {
      background-image: url('../../assets/images/Corporate-honor.png'); // 企业荣誉
    }
    &.t4 {
      background-image: url('../../assets/images/Contact-us.png');
    }
    &.t5 {
      background-image: url('../../assets/images/Contact-zizhi.png');
    }
  }
  .product {
    position: relative;
    z-index: 1;
    h2 {
      width: 338px;
      height: 68px;
      line-height: 68px;
      color: #6a6a6a;
      font-size: 24px;
      border-bottom: 2px solid #00dcd4;
      text-align: center;
      margin: 0 auto;
      em {
        color: #00dcd4;
      }
    }
    .details {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 80px 0;
      .img {
        width: 558px;
        min-height: 314px;
        position: relative;
        // background: #DDF6F5;
        // border-radius: 10px;
        // margin-left: 15px;
        .p1 {
          width: 558px;
          height: 262px;
          margin-top: 26px;
          background: #d6f8f7;
        }
        .p2 {
          width: 468px;
          height: 314px;
          margin: 0 auto;
          position: absolute;
          top: 0;
          left: 45px;
          img {
            width: 100%;
          }
        }
      }
      .text {
        width: 598px;
        margin-top: 49px;
        // padding: 26px 30px;
        // margin-right: 30px;
        // box-shadow:1px 1px 24px 0px rgba(0, 0, 0, 0.14);
        // border-radius: 40px;
        position: relative;
        p {
          text-indent: 40px;
          font-size: 18px;
          line-height: 36px;
          color: #6a6a6a;
        }
        .site {
          width: 365px;
          margin-left: 35px;
          line-height: 28px;
          .dl {
            display: flex;
            margin-top: 18px;
            .dt {
              width: 75px;
              &::before {
                content: '';
                display: block;
                float: left;
                width: 22px;
                height: 22px;
                margin-top: 3px;
                margin-right: 5px;
                background-position: center;
                background-repeat: no-repeat;
              }
              &.address::before {
                background-image: url('../../assets/images/address2.png');
              }
              &.tel::before {
                background-image: url('../../assets/images/tel2.png');
              }
              &.email::before {
                background-image: url('../../assets/images/email2.png');
              }
            }
            .dd {
              flex: 1;
            }
          }
          .code {
            width: 100px;
            height: 100px;
            position: absolute;
            top: 80px;
            left: 270px;
            span {
              display: block;
              text-align: center;
              margin-top: -12px;
            }
          }
        }
      }
    }
    .details2 {
      margin-top: 30px;
      column-count: 3;
      column-gap: 15px;
      ul{
        padding: 0;
        margin: 0;
        list-style: none;
        li{
          break-inside: avoid;
          margin-bottom: 15px;
          position: relative;
          img{
            width: 100%;
            display: block;
            border: 1px solid #fff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
          }
          .overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 10%;
            background: rgba(0, 0, 0, 0.5);
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s;
            p {
              font-size: 14px;
              margin: 0;
              padding: 10px;
              line-height: 20px;
            }
          }
        }
        li:hover .overlay{
          opacity: 1;
        }
      }
    }
    .details3{
      .img{
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
      }
      .tit{
        margin-bottom: 20px;
        font-size: 18px;
        color: #6a6a6a;
        h3{
          color: #3366FF;
          margin-bottom: 10px;
        }
        p{
          font-size: 18px;
          line-height: 36px;
        }
      }
    }
    .details4 {
      margin: 80px 0;
      p{
        font-size: 26px;
        color: red;
        text-align: center;
        margin-bottom: 20px;
      }
      ul{
        padding: 0;
        margin: 0;
        list-style: none;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        li{
          break-inside: avoid;
          margin-bottom: 15px;
          margin-right: 15px;
          img{
            width: 100%;
            display: block;
            border: 1px solid #fff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
          }
        }
      }
    }
    .step {
      column-count: 4;
      column-gap: 15px;
      margin: 80px 0;
      display: flex;
      flex-direction: column;
      .stepimgtit{
        display: flex;
        margin-bottom: 20px;
        img{
          width: 400px;
          border: 1px solid #fff;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
        }
        .tit{
          margin-left: 30px;
          font-size: 18px;
          color: #6a6a6a;
          line-height: 36px;
          & p:nth-child(1){
            font-size: 20px;
            font-weight: 700;
            line-height: 36px;
            padding-bottom: 10px;
          }
        }
      }
    }
    .map img {
      display: block;
      margin: 0 auto;
      padding: 30px;
      background: #fafafc;
      border-radius: 10px;
    }
  }
}
.tab {
  background: #fafafa;
  width: 100%;
  height: 100px;
  padding: 30px 0;
  position: absolute;
  top: 0;
  right: 10px;
  &.fixed {
    position: fixed;
    z-index: 10;
    width: 150px;
    // top: 76px;
    top: 100px;
    // left: 50%;
    // margin-left: 450px;
    background: none;
    .inner {
      width: 100%;
    }
    a {
      margin-left: 0;
      margin-bottom: 20px;
    }
  }
  .inner {
    width: 1200px;
    margin: 0 auto;
  }
  a {
    font-size: 16px;
    color: #00dcd4;
    background-color: #fff;
    width: 150px;
    line-height: 38px;
    border: 1px solid #00dcd4;
    text-align: center;
    border-radius: 20px;
    margin-left: 133px;
    display: inline-block;
    // &:hover
    &.active {
      background: #00dcd4;
      color: #fff;
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
.tabs {
  a {
    font-size: 16px;
    color: #00dcd4;
    background-color: #fff;
    width: 150px;
    line-height: 38px;
    border: 1px solid #00dcd4;
    text-align: center;
    border-radius: 20px;
    margin-left: 133px;
    display: inline-block;
    // &:hover
    &.active {
      background: #00dcd4;
      color: #fff;
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
